import React, { memo, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getCustomerProfile } from 'src/selectors/customer'
import { CustomerCollectedDataType } from 'src/constants/customer/enums'
import { useNavigate } from 'react-router-dom'
import { FullScreenLoader } from 'src/components/shared/FullScreenLoader'
import { Button } from 'src/components/shared/Button'
import tw from 'twin.macro'
import { ChevronLeftMinor } from '@shopify/polaris-icons'
import { CustomerBusinessDetailsForm } from 'src/components/customer/customer-business-details-form/CustomerBusinessDetailsForm'
import { ROUTES } from 'src/constants/routes'

const CustomerResubmitBusinessDetailsPageComponent = () => {
  const navigate = useNavigate()

  const customerProfile = useSelector(getCustomerProfile)

  const initialValues = useMemo(() => {
    const businessDetails = customerProfile?.collectedData.find(
      (item) => item.type === CustomerCollectedDataType.BusinessDetails,
    )?.data

    return {
      doesBusinessAdvertise: businessDetails?.doesBusinessAdvertise ? 'yes' : 'no',
      hasQualityProgram: businessDetails?.hasQualityProgram ? 'yes' : 'no',
      qualityProgramDetails: businessDetails?.qualityProgramDetails || '',
      vehicleAccessDetails: businessDetails?.vehicleAccessDetails || '',
      coveredCitiesDetails: businessDetails?.coveredCitiesDetails || '',
    }
  }, [customerProfile?.collectedData])

  const handleBack = useCallback(() => {
    navigate(ROUTES.BASE_URL)
  }, [navigate])

  if (!customerProfile) {
    return <FullScreenLoader />
  }

  return (
    <>
      <CustomerBusinessDetailsForm initialValues={initialValues} onSubmit={handleBack} />
      <div css={tw`absolute left-4 top-20`}>
        <Button
          onClick={handleBack}
          leftIcon={<ChevronLeftMinor width={20} height={20} fill="white" />}
          size="small"
          color="black"
        >
          Back
        </Button>
      </div>
    </>
  )
}

export const CustomerResubmitBusinessDetailsPage = memo(
  CustomerResubmitBusinessDetailsPageComponent,
)
